import type { Branded } from '@festina-life/core'
import type { FC, JSX } from 'react'

import { useAvailableComponents } from '../../hooks/useAvailableComponents'
import { NullReturn } from '../actions/NullReturn'

/**
 * HOC that will cause the wrapped to component to only be mounted when a legal entity or life component exists.
 */
export const withLegalEntityOrLife = <T,>(
  WrappedComponent: FC<T>,
): Branded<FC<T>, 'Area'> => {
  const WrapperComponent = (props: T & JSX.IntrinsicAttributes) => {
    const { isUsingLegalEntity, isUsingLife } = useAvailableComponents()

    return isUsingLegalEntity || isUsingLife ? (
      <WrappedComponent {...props} />
    ) : (
      <NullReturn />
    )
  }

  WrapperComponent.displayName = `${
    WrappedComponent.displayName || WrappedComponent.name || 'Unknown'
  }WrapperComponent`

  return WrapperComponent as Branded<FC<T>, 'Area'>
}
